import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import classnames from 'classnames';
import renderHtml from 'react-render-html';
import * as userActions from '../../../actions/userActions';
import HeaderSearch from './HeaderSearch';
import MainMenu from '../Menus/MainMenu';
import AccountMenu from '../Menus/AccountMenu';
import NotificationIcon from '../Icons/NotificationIcon';
import Icon from '../Icons/Icon';
import IconWithText from '../Icons/IconWithText';
import UserAvatar from '../Avatars/UserAvatar';
import Dropdown from '../Dropdowns/Dropdown';
import Button from '../Buttons/Button';

class Header extends Component {
  constructor(props) {
    super(props);
    this.state = {
      searchTerm: ``,
      searchLoading: false,
      searchActive: false,
    };
  }

  componentDidMount() {
    this.checkIfOnSearchPage();
  }

  checkIfOnSearchPage = () => {
    if (this.props.location.query && this.props.location.query.term) {
      this.setState({ searchTerm: this.props.location.query.term, searchActive: true });
    }
  }

  handleSearchTermChange = (e) => {
    this.setState({ searchTerm: e.target.value });
  }

  handleSearchSubmit = (e) => {
    e.preventDefault();
    this.setState({ searchLoading: true, searchActive: true });
    window.location.href = `/search?term=${this.state.searchTerm}`;
  }

  handleMobileSearchTriggerClick = () => {
    this.setState({ searchActive: !this.state.searchActive }, () => {
      if (this.state.searchActive) {
        // We set visiblity: hidden on the search bar on mobile until a click of the search trigger
        // This isn't possible without the setTimeout
        setTimeout(this.focusOnSearchInput, 100);
      }
    });
  }

  focusOnSearchInput = () => {
    this.searchInput.focus();
  }

  render() {
    const { location, organisation, loggedInUser } = this.props;
    const { searchTerm, searchLoading, searchActive } = this.state;

    const headerClasses = classnames(`header d-flex align-items-center bg-black box-shadow-m`, {
      'header--mobile-search-active': searchActive,
    });

    const headerStyles = {
      borderTop: `5px solid ${organisation.primaryColour}`,
    };

    return (
      <header className={headerClasses} style={headerStyles}>
        <a href="/training-ground" className="header__logo m-r-5 flex-shrink-0">
          {organisation.primaryLogo &&
            renderHtml(organisation.primaryLogo)
          }
        </a>

        <div className="m-r-5">
          <HeaderSearch
            searchTerm={searchTerm}
            onSearchTermChange={this.handleSearchTermChange}
            onSearchSubmit={this.handleSearchSubmit}
            searchLoading={searchLoading}
            onBackClick={this.handleMobileSearchTriggerClick}
            inputRef={(input) => { this.searchInput = input; }}
          />
        </div>

        <div className="header__main-menu-container"><MainMenu activeRoute={location.pathname} /></div>

        <div className="header__right d-flex align-items-center">
          <Button onClick={this.handleMobileSearchTriggerClick} classes="header__mobile-search-trigger flex-shrink-0 icon--m" faux>
            <Icon name="search" fill="white" />
          </Button>

          {/* <div className="header__notifications">
            <Dropdown size="m" position="right" noArrow label={<NotificationIcon newNotificationCount={4} fill="white" />}>
              <AccountMenu loggedInUser={loggedInUser} />
            </Dropdown>
          </div> */}

          <div className="flex-shrink-0">
            {loggedInUser.notLoggedIn ? (
              <a href="/login" className="btn btn--s"><IconWithText name="outline-key" size="s">Login</IconWithText></a>
            ) : (
              <div className="header__account-menu">
                <Dropdown size="m" position="right" label={<UserAvatar image={loggedInUser.image_url} />} noArrow>
                  <AccountMenu loggedInUser={loggedInUser} billingEnabled={loggedInUser.billing_enabled} />
                </Dropdown>
              </div>
            )}
          </div>
        </div>
      </header>
    );
  }
}

Header.propTypes = {
  location: PropTypes.object.isRequired,
  organisation: PropTypes.object.isRequired,
  loggedInUser: PropTypes.object.isRequired,
};

function mapStateToProps(state) {
  return {
    organisation: state.organisation,
    loggedInUser: state.loggedInUser,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(Object.assign({}, userActions), dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Header);



// WEBPACK FOOTER //
// ./library/app/components/Global/Header/Header.js